import {useRef} from "react";

export function useFallbackRef(forwardedRef) {
  const fallbackRef = useRef(null)
  return forwardedRef || fallbackRef
}